import React, {Component} from "react";

class AddThis extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.els = {}
    this.onUpdate = this.onUpdate.bind(this);
  }

  componentDidMount() {
    this.els.container = this.props.proxy.parentNode;
    this.els.element = this.props.proxy;

    this.els.titleAuthor = document.querySelector('.title-author');
    let h = this.els.titleAuthor.offsetHeight;
    h += parseInt(window.getComputedStyle(this.els.titleAuthor).getPropertyValue('margin-top'));
    h += parseInt(window.getComputedStyle(this.els.titleAuthor).getPropertyValue('margin-bottom'));
    let windowWidth = window.innerWidth

    if (windowWidth <= 1023) h = 0
    this.setState({h}, () => {
      this.els.container.style.marginTop = `-${this.state.h}px`
    })

    window.addEventListener('resize', this.onUpdate);
    window.addEventListener('scroll', this.onUpdate);
    this.onUpdate();
  }

  onUpdate() {
    if (window.innerWidth >= 1024) {
      this.els.element.style.position = "initial";
      return;
    }
    let containerRect = this.els.container.getBoundingClientRect();

    if (containerRect.top > window.innerHeight - this.els.element.offsetHeight) {
      this.els.element.style.position = "fixed";
      this.els.element.style.bottom = 0;
      this.els.container.style.marginTop = 0;
    } else {
      let h = this.state.h
      if (window.innerWidth <= 1023) h = 0
      this.els.element.style.position = "initial";
      this.els.container.style.marginTop = `-${h}px`;
    }
  }


  render() {
    return <div></div>
  }
}

export default (AddThis);



// WEBPACK FOOTER //
// ./vendor/bbs/crt/src/resources/views/components/add-this/AddThis.js